import { useEffect, useState } from "react";
import { CREATE_CHAT_FREE_TURN_LIMIT } from "@/lib/createChatCreditGate";

/**
 * The admin-configured create-chat free-turn limit. Starts at the compiled
 * default and updates once the public config endpoint responds; a fetch
 * failure just leaves the default in place (the server gate is authoritative
 * either way).
 */
export function useCreateChatFreeTurnLimit(): number {
  const [limit, setLimit] = useState(CREATE_CHAT_FREE_TURN_LIMIT);

  useEffect(() => {
    let cancelled = false;

    fetch("/api/create/chat-config", {
      method: "GET",
      headers: { Accept: "application/json" },
    })
      .then(response => (response.ok ? response.json() : null))
      .then(data => {
        const value = Number(data?.freeTurnLimit);
        if (!cancelled && Number.isInteger(value) && value > 0) {
          setLimit(value);
        }
      })
      .catch(() => {
        // Keep the compiled default; the server gate still enforces the
        // real limit.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return limit;
}
